import React, { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { History } from 'history'
import { CloudArrowUpIcon } from '@heroicons/react/24/outline'
import { ADD_PHOTOS_STORE, AddPhotosStore } from '../../../stores/AddPhotosStore'
import { getUploadProgress } from './uploadProgress'

export const UploadProgressSnackBar: React.FC<{
  [ADD_PHOTOS_STORE]?: AddPhotosStore
  history: History
  workspaceSlug: string
}> = inject(ADD_PHOTOS_STORE)(
  observer((props) => {
    const { history, workspaceSlug } = props
    const store = props[ADD_PHOTOS_STORE]!
    const { filesCount, uploadedCount, currentUploadingFile, isUploading } = store

    const currentFileProgress = isUploading ? currentUploadingFile?.upload?.progress ?? 0 : 0
    const progress = getUploadProgress({ filesCount, uploadedCount, currentFileProgress })
    const isOnUploadPage = history.location.pathname.includes('/add')
    const show = isUploading && !isOnUploadPage

    const [isVisible, setIsVisible] = useState(false)
    const [isAnimating, setIsAnimating] = useState(false)

    useEffect(() => {
      if (show) {
        setIsVisible(true)
        requestAnimationFrame(() => requestAnimationFrame(() => setIsAnimating(true)))
      } else {
        setIsAnimating(false)
        const timer = setTimeout(() => setIsVisible(false), 200)
        return () => clearTimeout(timer)
      }
    }, [show])

    if (!isVisible) return null

    return (
      <div
        className={`fixed bottom-5 right-5 z-[1] w-[220px] select-none overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition-all duration-200 ease-out ${
          isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'
        }`}
      >
        <button
          type="button"
          onClick={() => history.push(`/${workspaceSlug}/upload`)}
          className="flex w-full flex-col"
        >
          <div className="flex w-full items-center gap-2 px-3 py-2">
            <CloudArrowUpIcon className="h-5 w-5 shrink-0 text-gray-500" />
            <span className="flex-1 text-left text-xs font-medium text-gray-700">Przesyłanie</span>
            <span className="text-xs text-gray-500">{Math.round(progress)}%</span>
          </div>
          <div className="h-1 w-full bg-gray-200">
            <div
              className="h-full bg-indigo-600 transition-all duration-150"
              style={{ width: `${progress}%` }}
            />
          </div>
        </button>
      </div>
    )
  })
)
